export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { data, expires } = JSON.parse(raw);
    if (Date.now() > expires) { localStorage.removeItem(key); return null; }
    return data;
  } catch { return null; }
}

export function cacheSet(key, data, ttl) {
  try { localStorage.setItem(key, JSON.stringify({ data, expires: Date.now() + ttl })); }
  catch {}
}
